import React from 'react';
import ImportWithMappingDialog from '../../../components/common/ImportWithMappingDialog';
import { epiService } from '../../../services/epiService';
import type { ImportServiceAdapter, MappingColumnConfig } from '../../../types/import';

interface EPIImportDialogProps {
  open: boolean;
  onClose: () => void;
  onImportComplete: () => void;
}

const COLUMNS: MappingColumnConfig[] = [
  { key: 'tipo_de_risco', label: 'Tipo de Risco', valueType: 'string' },
];

const COLUMN_LABELS: Record<string, string> = {
  tipo_de_risco: 'Tipo de Risco',
};

const epiImportAdapter: ImportServiceAdapter = {
  previewImport: (file) => epiService.previewImport(file),
  executeImport: async (file, mappings) => {
    const result = await epiService.importEpis(file, {
      mappings: mappings as Record<string, Record<string, string>> | undefined,
    });
    return {
      imported: result.imported,
      skipped: result.skipped,
      errors: result.errors,
    };
  },
  downloadTemplate: () => epiService.downloadTemplate(),
};

const EPIImportDialog: React.FC<EPIImportDialogProps> = ({
  open,
  onClose,
  onImportComplete,
}) => {
  return (
    <ImportWithMappingDialog
      open={open}
      onClose={onClose}
      onImportComplete={onImportComplete}
      title="Importar EPIs"
      description="Selecione um arquivo Excel (.xlsx) com os EPIs para importar. Registros duplicados serão ignorados."
      entityLabel="EPI"
      templateFilename="template-importacao-epis.xlsx"
      adapter={epiImportAdapter}
      columns={COLUMNS}
      columnLabels={COLUMN_LABELS}
      getImportOptions={() => ({})}
    />
  );
};

export default EPIImportDialog;
